export default "__VITE_ASSET__c8e088dd__"